export const Dienststelle = [
  {
    'PAISY-Wert': 'AFS',
    Bezeichnung: 'Amt für (Familie und) Soziales',
  },
  {
    'PAISY-Wert': 'VA',
    Bezeichnung: 'Versorgungsamt',
  },
  {
    'PAISY-Wert': 'BG',
    Bezeichnung: 'Sonstige / § 69 Abs. 2 SGB IX',
  },
  {
    'PAISY-Wert': 'AA',
    Bezeichnung: 'Arbeitsamt / Arbeitsagentur',
  },
  {
    'PAISY-Wert': 'ZST',
    Bezeichnung: 'Zentralstelle für den Bergmannsversorgungsschein',
  },
  {
    'PAISY-Wert': 'EIN',
    Bezeichnung: 'Einrichtung nach § 35 SGB IX',
  },
  {
    'PAISY-Wert': 'WFBM',
    Bezeichnung: 'Werkstatt für behinderte Menschen',
  },
];
